import { CHANNEL } from '@boss/constants/corporate-jobs';
import { IIVacancy, SectionFields, SimpleImage } from '@boss/types/corporate-jobs';

import B2b from './B2b';
import B2c from './B2c';
import ComponentMapper from '../../mappers/ComponentMapper';

type Props = {
  jobs: (IIVacancy | null)[];
  pageTitle: string;
  locale: string;
  enrichedSections?: SectionFields[];
  locations: string[];
  bannerImage?: SimpleImage | null;
};

const JobsPage = ({ jobs, pageTitle, locale, locations, enrichedSections, bannerImage }: Props) => (
  <div>
    <div className="mb-14">
      {CHANNEL === 'jobs-b2c' ? (
        <B2c bannerImage={bannerImage} jobs={jobs} locale={locale} locations={locations} pageTitle={pageTitle} />
      ) : (
        <B2b jobs={jobs} locale={locale} pageTitle={pageTitle} />
      )}
    </div>
    {enrichedSections && (
      <div className="mb-14">
        {enrichedSections.map(entry => (
          <ComponentMapper entry={entry} key={entry.id} locale={locale} />
        ))}
      </div>
    )}
  </div>
);

export default JobsPage;
